module.exports = __webpack_public_path__ + "img/local_mall.3a9e00e8.svg";